import { render } from "./Popup.vue?vue&type=template&id=32532639"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=32532639&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__